import React, { useState, useEffect } from 'react';
import { useTable, usePagination, useGlobalFilter } from "react-table";
import { useForm } from "react-hook-form";
import { Modal, Toast } from 'react-bootstrap';
import Select from 'react-select';
import Api from '../Auth/Api';
import { decodeJWT } from "../Components/jwtUtils";

function TableUnidades({ columns, data, titulo }) {
    const token = JSON.parse(localStorage.getItem("user_token"));
    const nivel = decodeJWT(token).nivel;
    
    const [showModalAdicionarUnidade, setShowModalAdicionarUnidade] = useState(false);
    const [toast, setToast] = useState({});
    const [showToast, setShowToast] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dataEmpresas, setDataEmpresas] = useState([]);
    const [selectedEmpresa, setSelectedEmpresa] = useState(null);

    const { register, handleSubmit, reset, formState: { errors } } = useForm();

    const props = useTable(
        { 
            columns, 
            data, 
            initialState: { pageSize: 20 } 
        }, 
        useGlobalFilter, 
        usePagination
    );
    
    const {
        getTableBodyProps,
        rows,
        prepareRow,
        setGlobalFilter,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        nextPage,
        previousPage,
        setPageSize,
        state: { pageIndex, pageSize, globalFilter }
    } = props;

    // Buscar empresas para seleção (apenas para administradores)
    useEffect(() => {
        if (nivel === 'Administrador') {
            async function fetchEmpresas() {
                try {
                    const response = await Api.get(`api/listar-empresas`, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    });
                    setDataEmpresas(response.data);
                } catch (error) {
                    console.error('Erro ao carregar empresas:', error);
                    setDataEmpresas([]);
                }
            }
            fetchEmpresas();
        }
    }, [token, nivel]);

    useEffect(() => {
    }, [globalFilter]);

    const onSubmitAdicionarUnidade = async (data) => {
        setLoading(true);
        
        // Validar se administrador selecionou uma empresa
        if (nivel === 'Administrador' && !selectedEmpresa) {
            setToast({ header: 'Ops!', body: 'Por favor, selecione uma empresa.' });
            setShowToast(true);
            setLoading(false);
            return;
        }
        
        // Adicionar id_empresa se for administrador e empresa foi selecionada
        if (nivel === 'Administrador' && selectedEmpresa) {
            data.id_empresa = selectedEmpresa.value;
        }
        
        try {
            const response = await Api.post(`api/nova-unidade`, data, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setToast({ header: 'Sucesso!', body: response.data.message });
            reset();
            setSelectedEmpresa(null);
            setShowModalAdicionarUnidade(false);
            // Recarregar a página para atualizar a lista
            window.location.reload();
        } catch (error) {
            setToast({ header: 'Ops!', body: error.response?.data?.message || 'Erro ao criar unidade' });
            console.error("Erro ao criar unidade:", error);
        }
        setLoading(false);
        setShowToast(true);
    };

    const customStyles = {
        container: (base) => ({
            ...base,
            width: '100%',
        }),
        control: (base, state) => ({
            ...base,
            fontSize: "1rem",
            backgroundColor: "#ffffff",
            borderRadius: "0.25rem",
            boxShadow: state.isFocused ? "0 0 0 0.25rem #27485b73" : null,
            borderColor: "#dee2e6",
            "&:hover": {
                borderColor: "#dee2e6"
            },
        }),
        singleValue: (base) => ({
            ...base,
            color: '#000',
            marginTop: '5px',
        }),
        input: (base) => ({
            ...base,
            color: '#adb5bd',
            height: "46px",
            margin: '0px',
            padding: '0px !important',

        }),
        menu: (base) => ({
            ...base,
            backgroundColor: '#fff',
        }),
        option: (base, state) => ({
            ...base,
            color: state.isSelected ? '#3a5a6c' : null,
            backgroundColor: state.isFocused ? '#27485b73' : null,
            "&:active": {
                backgroundColor: "#27485b73"
            },
        }),
    };


    return (
        <>
            <Toast show={showToast} onClose={() => setShowToast(false)} delay={3000} autohide style={{ position: 'fixed', left: '95%', bottom: '10px', transform: 'translateX(-95%)', zIndex: 9999, padding: 0 }}>
                <Toast.Header>
                    <strong className="mr-auto">{toast.header}</strong>
                </Toast.Header>
                <Toast.Body>{toast.body}</Toast.Body>
            </Toast>

            <section className="w-100">
                <div className="d-flex flex-column">
                    <div className="row d-flex align-items-center justify-content-start">
                        <div className="col-md-8 col-lg-8 col-xl-6">
                            <div className="inner-addon right-addon">
                                <i className="d-flex bi bi-search" />
                                <input
                                    value={globalFilter || ""}
                                    onChange={e => setGlobalFilter(e.target.value)} 
                                    type="search"
                                    placeholder="Pesquise pelo nome da unidade..."
                                    className="form-control py-2"
                                />
                            </div>
                        </div>
                        <div className="d-flex mt-2 align-items-center justify-content-start col-md-3 col-lg-3 col-xl-2 col-xxl-2">
                            <select className="form-select py-2" value={pageSize} onChange={e => { setPageSize(Number(e.target.value)) }}>
                                <option disabled>Quantidade</option>
                                {[20, 50, 100, 500, 1000].map(pageSize => (
                                    <option key={pageSize} value={pageSize}>
                                        {pageSize}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {/* Só mostra o botão de adicionar para Administrador e Moderador */}
                        {(nivel === 'Administrador' || nivel === 'Moderador') && (
                            <div className="d-flex mt-2 align-items-center justify-content-start col-md-4 col-xl-4">
                                <button
                                    onClick={() => {
                                        setSelectedEmpresa(null);
                                        setShowModalAdicionarUnidade(true);
                                    }}
                                    className="btn btn-primary text-white px-4 py-2 w-100"
                                >
                                    <i className="bi bi-plus-circle me-2"></i>
                                    Nova Unidade
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </section>

            <div className="table-full-width mt-3 mb-3">
                <div className="table-responsive">
                    <table className="table align-middle mt-1 table-striped table-hover">
                        <thead>
                            <tr>
                                <th colSpan="5" className='bg-primary text-white rounded-top'>{titulo}</th>
                            </tr>
                        </thead>
                        <thead>
                            <tr className='border border-white text-nowrap'>
                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted'>ID</th>
                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted'>Nome</th>
                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted'>Empresa</th>
                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted'>Status</th>
                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted text-center'>Ações</th>
                            </tr>
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {page.map((row, i) => {
                                prepareRow(row);
                                return (
                                    <tr className='text-nowrap' {...row.getRowProps()}>
                                        {row.cells.map(cell => {
                                            return (
                                                <td {...cell.getCellProps()}>
                                                    {cell.render("Cell")}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                );
                            })}
                        </tbody>
                        <tfoot>
                            <tr>
                                <th colSpan="5" className='bg-primary text-white rounded-bottom'>
                                    <div className="table-footer d-flex justify-content-between align-items-center">
                                        <span>Exibindo {pageSize < rows.length ? pageSize : rows.length} de {rows.length} registros</span>
                                        <div>
                                            <span>Página {pageIndex + 1} de {pageOptions.length}</span>
                                            <button className="btn btn-primary btn-sm ms-2 text-white" onClick={() => previousPage()} disabled={!canPreviousPage}>
                                                <i className="bi bi-caret-left"></i>
                                            </button>
                                            <button className="btn btn-primary btn-sm ms-1 text-white" onClick={() => nextPage()} disabled={!canNextPage}>
                                                <i className="bi bi-caret-right"></i>
                                            </button>
                                        </div>
                                    </div>
                                </th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>

            {/* Modal Adicionar Unidade */}
            <Modal size="lg" show={showModalAdicionarUnidade} onHide={() => setShowModalAdicionarUnidade(false)}>
                <form onSubmit={handleSubmit(onSubmitAdicionarUnidade)}>
                    <Modal.Header closeButton>
                        <span className="fw-semibold fs-4 text-primary">Nova unidade</span>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="body">
                                        <div className="d-flex">
                                            <div className="d-flex flex-column w-100">
                                                <div className="row mb-3">
                                                    <div className="col-12">
                                                        <div className="mb-3">
                                                            <label className="form-label text-primary fw-medium">Nome da Unidade</label>
                                                            <input 
                                                                type="text" 
                                                                {...register("nome", { required: true })} 
                                                                placeholder="Nome da unidade" 
                                                                className="form-control border-primary"
                                                            />
                                                            {errors.nome && <span className='text-danger fs-7'>Nome da unidade é obrigatório.</span>}
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Campo empresa - apenas para administradores */}
                                                {(nivel === 'Administrador' || nivel === 'Moderador') && (
                                                    <div className="row mb-3">
                                                        <div className="col-12">
                                                            <div className="mb-3">
                                                                <label className="form-label text-primary fw-medium">Empresa</label>
                                                                <Select
                                                                    value={selectedEmpresa}
                                                                    onChange={setSelectedEmpresa}
                                                                    styles={customStyles}
                                                                    options={dataEmpresas.map(empresa => ({
                                                                        value: empresa.id,
                                                                        label: empresa.titulo
                                                                    }))}
                                                                    placeholder="Selecione uma empresa"
                                                                    noOptionsMessage={() => "Nenhuma empresa encontrada"}
                                                                    className="react-select-container"
                                                                    classNamePrefix="react-select"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-center bg-light">
                        <button
                            type="submit"
                            className="btn btn-primary text-white px-5 py-2"
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    Salvando...
                                </>
                            ) : (
                                'Salvar'
                            )}
                        </button>
                        <button
                            type="button"
                            className="btn btn-outline-primary text-primary px-5 py-2 ms-4"
                            onClick={() => setShowModalAdicionarUnidade(false)}
                            disabled={loading}
                        >
                            Cancelar
                        </button>
                    </Modal.Footer>
                </form>
            </Modal>
        </>
    );
}

export default TableUnidades; 